import { Menu, Modal, Utils } from 'common';
import map from 'lodash/map';
import React, { Component } from 'react';
import { SettingsLeftMenuItems } from './SettingsLeftMenuItems';

const { MenuPanel, ActionType, ItemType } = Menu;
const { ModalContext } = Modal;
const { Logger } = Utils;

export class SettingsLeftMenuView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentActive: 'generalSettings',
			menuItems: [],
		};
	}

	componentDidMount() {
		this.buildLeftMenu();
	}

	buildLeftMenu = () => {
		this.setState({
			menuItems: SettingsLeftMenuItems.build(),
		});
	};

	handleNavigation = ({ actionType, itemType, data }) => {
		const { id, navigationToken } = data;
		const { settingsModalCallback } = this.props;
		const { menuItems } = this.state;

		if (actionType === ActionType.Click && itemType === ItemType.Badge) {
			// refresh the main view
			settingsModalCallback(navigationToken);

			// refresh the menu view
			this.setState({
				menuItems: map(menuItems, menuItem => {
					// highlight the selected menu item
					menuItem.active = menuItem.id === id;

					return menuItem;
				}),
			});
		}
	};

	actionTriggerHandler = (actionType, itemType, data) => {
		const { navigationToken } = data;
		const { currentActive } = this.state;
		const tabNames = {
			generalSettings: 'general_settings',
			manageUsers: 'manage_users',
			shipFromAddress: 'ship_from_address',
			costCodes: 'cost_codes',
			defaultPayment: 'default_payment',
			contactInformation: 'contact_information',
		};

		Logger.logToServer({
			category: 'location_dialog',
			action: 'tab_change',
			currentTab: tabNames[currentActive],
			newTab: tabNames[navigationToken],
		});

		this.handleNavigation({ actionType, itemType, data });

		this.setState({
			currentActive: navigationToken,
		});
	};

	render() {
		const { menuItems } = this.state;

		return (
			<MenuPanel
				items={menuItems}
				onActionTrigger={this.actionTriggerHandler}
			/>
		);
	}
}

SettingsLeftMenuView.contextType = ModalContext;
